export enum SeedErrorCode {
  HomeBranch = 'urn:errors:invalid-homebranch',
  InvalidAccount = 'urn:errors:invalid-account',
  InvalidOrder = 'urn:errors:invalid-order',
  PriceUpdateDenied = 'urn:errors:price-update-denied',
  InternalNotesDenied = 'urn:errors:internal-notes-update-denied',
  InvalidStore = 'urn:errors:invalid-store',
}
